import React, { useEffect, useRef, useState } from 'react';
import './Timeline.css';

export default function Timeline({ styxPercent = 30, tradPercent = 95 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // small delay so the bars animate after entering
            setTimeout(() => setVisible(true), 220);
            io.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, []);

  return (
    <div
      className={`timeline ${visible ? 'visible' : ''}`}
      ref={ref}
      style={{ ['--styx-percent']: `${styxPercent}%`, ['--trad-percent']: `${tradPercent}%` }}
    >
      <div className="heading">
        <div className="accent" aria-hidden="true" />
        <h4>Timeline Advantage: 75–85% Faster Than Traditional Discovery</h4>
      </div>

      <div className="row">
        <div className="label">Styx Platform</div>
        <div className="bar-wrap">
          <div className="bar styx" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={visible ? styxPercent : 0} />
        </div>
        <div className="time">6–10 weeks</div>
      </div>

      <div className="row">
        <div className="label">Traditional Discovery</div>
        <div className="bar-wrap">
          <div className="bar traditional" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={visible ? tradPercent : 0} />
        </div>
        <div className="time">18–24 months</div>
      </div>
    </div>
  );
}

